export const Svg_127 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M13.125 32.083c-1.264 0-2.31-.413-3.136-1.24-.826-.826-1.24-1.87-1.24-3.135 0-1.264.414-2.309 1.24-3.135.827-.826 1.872-1.24 3.136-1.24s2.309.414 3.135 1.24c.827.826 1.24 1.871 1.24 3.135 0 1.264-.413 2.31-1.24 3.136-.826.826-1.871 1.24-3.135 1.24ZM8.75 64.167V49.583H5.833V37.917c0-.827.28-1.52.839-2.078C7.23 35.279 7.923 35 8.75 35h8.75c.826 0 1.519.28 2.078.839.559.559.838 1.251.838 2.078v11.666H17.5v8.75h23.333V43.75H35.73c-3.451 0-6.38-1.203-8.787-3.61-2.406-2.406-3.609-5.334-3.609-8.786 0-2.576.693-4.873 2.078-6.89 1.386-2.018 3.172-3.513 5.36-4.485.534-3.16 2.005-5.821 4.411-7.984 2.406-2.163 5.262-3.245 8.568-3.245 3.305 0 6.161 1.082 8.568 3.245 2.406 2.163 3.876 4.824 4.411 7.984 2.188.972 3.974 2.467 5.36 4.485 1.385 2.017 2.078 4.314 2.078 6.89 0 3.452-1.204 6.38-3.61 8.787-2.406 2.406-5.335 3.609-8.786 3.609h-5.105v14.583H61.25v5.834H8.75Zm26.979-26.25h16.042c1.847 0 3.402-.632 4.666-1.896 1.264-1.264 1.896-2.82 1.896-4.667 0-1.312-.352-2.503-1.057-3.573-.705-1.07-1.665-1.871-2.88-2.406l-3.063-1.313-.437-3.208c-.292-1.798-1.106-3.293-2.443-4.484-1.337-1.191-2.905-1.787-4.703-1.787-1.799 0-3.367.596-4.703 1.787-1.337 1.19-2.151 2.686-2.443 4.484l-.438 3.209-3.062 1.312c-1.215.535-2.175 1.337-2.88 2.406-.705 1.07-1.058 2.26-1.058 3.573 0 1.847.632 3.403 1.896 4.667 1.264 1.264 2.82 1.896 4.667 1.896Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={45.022}
        y1={17.063}
        y2={60.843}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)